import axios from "../utils/axios";

// Get all projects
export const getProjects = async (params = {}) => {
    const response = await axios.get('/projects', { params });
    return response.data;
};

// Get single project
export const getProject = async (id) => {
    const response = await axios.get(`/projects/${id}`);
    return response.data;
};

// Create project
export const createProject = async (data) => {
    const response = await axios.post('/projects', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

// Update project
export const updateProject = async (id, data) => {
    const response = await axios.post(`/projects/${id}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

// Delete project (soft delete)
export const deleteProject = async (id) => {
    const response = await axios.delete(`/projects/${id}`);
    return response.data;
};

// Force delete project
export const forceDeleteProject = async (id) => {
    const response = await axios.delete(`/projects/${id}/force-delete`);
    return response.data;
};

// Restore project
export const restoreProject = async (id) => {
    const response = await axios.post(`/projects/${id}/restore`);
    return response.data;
};

export const massDestroyProjects = async (data) => {
    const response = await axios.delete('/projects/mass-destroy', { data });
    return response.data;
};

export const massForceDeleteProjects = async (data) => {
    const response = await axios.delete('/projects/mass-force-delete', { data });
    return response.data;
};

export const massRestoreProjects = async (data) => {
    const response = await axios.post('/projects/mass-restore', data);
    return response.data;
};